import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ChagePasswordPage } from './chage-password';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { DirectivesModule } from '../../directives/directives.module';

@NgModule({
  declarations: [
    ChagePasswordPage,
  ],
  imports: [
    IonicPageModule.forChild(ChagePasswordPage),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http: HttpClient) => new TranslateHttpLoader(http),
          deps: [ HttpClient ]
        }
    }), 
    DirectivesModule
  ],
})
export class ChagePasswordPageModule {}



// WEBPACK FOOTER //
// ./src/pages/chage-password/chage-password.module.ts